const CONFIGURED_FLOORPLAN_BASE_URL = String(import.meta.env.VITE_FLOORPLAN_BASE_URL || '').trim()
const LEGACY_FLOORPLAN_BASE_URL = 'https://hbfa-sales-ui.netlify.app'

function stripTrailingSlash(value) {
  return String(value || '').replace(/\/+$/, '')
}

export function resolveFloorplanUrl(rawUrl) {
  const value = String(rawUrl || '').trim()
  if (!value) return ''

  try {
    if (/^floorplans\//i.test(value)) {
      const baseUrl = CONFIGURED_FLOORPLAN_BASE_URL || LEGACY_FLOORPLAN_BASE_URL
      const base = new URL(stripTrailingSlash(baseUrl))
      return `${base.origin}/${value.replace(/^\/+/, '')}`
    }

    const parsed = new URL(value, window.location.origin)

    if (!parsed.pathname.startsWith('/floorplans/')) {
      return parsed.toString()
    }

    const isAbsoluteInput = /^[a-z]+:\/\//i.test(value)
    if (isAbsoluteInput && !CONFIGURED_FLOORPLAN_BASE_URL && parsed.origin !== window.location.origin) {
      return parsed.toString()
    }

    const baseUrl = CONFIGURED_FLOORPLAN_BASE_URL || LEGACY_FLOORPLAN_BASE_URL
    const base = new URL(stripTrailingSlash(baseUrl))
    return `${base.origin}${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return value
  }
}
